import { ColumnConfig } from '@/components/table/Table';
import { AssignmentApi } from '../models';
import { getAssetDisplayText } from '../../../components';

export const assignmentsTableColumns: ColumnConfig[] = [
  { 
    label: 'Equipo', 
    field: 'assetDisplay',
    render: (value: string, rowData: AssignmentApi) => getAssetDisplayText(rowData.asset)
  },
  {
    label: 'Número de serie',
    field: 'assetSerial',
    render: (value: string, rowData: AssignmentApi) => rowData.asset?.serialNumber || 'Sin número de serie'
  },
  {
    label: 'Estado',
    field: 'assetStatus',
    render: (value: string, rowData: AssignmentApi) => rowData.asset?.status || 'Estado no disponible'
  },
  {
    label: 'Condición',
    field: 'assetCondition',
    render: (value: string, rowData: AssignmentApi) => rowData.asset?.condition || 'Condición no disponible'
  },
  {
    label: 'Usuario',
    field: 'userName',
    render: (value: string, rowData: AssignmentApi) => rowData.user?.fullName || 'Sin usuario asignado'
  },
  {
    label: 'Email',
    field: 'userEmail',
    render: (value: string, rowData: AssignmentApi) => rowData.user?.email || 'Email no disponible'
  },
  { 
    label: 'Fecha de asignación', 
    field: 'assignedAt', 
    sortable: true 
  },
  {
    label: 'Fecha de devolución',
    field: 'returnedAt',
    sortable: true,
    render: (value: string | null) => value || 'Sin definir',
  },
];
